import React from "react";
import "./missionVisison.scss";
import vision from "../../../assets/UMSImage/vision.png";
import mission from "../../../assets/UMSImage/mission.png";

const MissionVisison = () => {
  return (
    <section id="mission-vision-wrapper">
      <div className="row">
        <div className="vision ">
          <img src={vision} alt="" />
          <h2>
            <span>Our</span> Vision
          </h2>
          <p>
            Medical billing services is to streamline the revenue cycle
            management process for healthcare providers, ensuring timely and
            accurate reimbursement for services rendered. We aim to leverage
            technology and expertise to improve efficiency, reduce costs, and
            enhance patient care.
          </p>
        </div>
        <div className="mission">
          <img src={mission} alt="" />
          <h2>
            <span>Our</span> Mission
          </h2>
          <p>
            Medical billing services is to provide comprehensive and reliable
            billing solutions to healthcare providers, enabling them to focus on
            delivering quality care to their patients. We strive to exceed
            client expectations by delivering customized solutions, exceptional
            customer service, and transparent communication throughout the
            billing process.
          </p>
        </div>
      </div>
    </section>
  );
};

export default MissionVisison;
